import { ErrorBoundary } from "react-error-boundary";

const RELOAD_KEY = "chunk_reload_attempted";

const isChunkError = (error) =>
  error?.name === "ChunkLoadError" ||
  error?.message?.includes("Loading chunk");

function ChunkErrorFallback() {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <p>
        A new version has been deployed.{" "}
        <button onClick={() => window.location.reload()}>
          Refresh the page
        </button>{" "}
        to continue.
      </p>
    </div>
  );
}

function ChunkErrorBoundary({ children }) {
  const handleError = (error) => {
    if (isChunkError(error) && !sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, "1");
      window.location.reload();
    }
  };

  const fallbackRender = ({ error, resetErrorBoundary }) => {
    if (isChunkError(error)) {
      return <ChunkErrorFallback />;
    }

    // Generic fallback for non-chunk errors — prevents blank screen
    console.error("[ChunkErrorBoundary] Unexpected application error:", error);
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        <p>Something went wrong.</p>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    );
  };

  return (
    <ErrorBoundary onError={handleError} fallbackRender={fallbackRender}>
      {children}
    </ErrorBoundary>
  );
}

export default ChunkErrorBoundary;
